var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationCircleFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22,-22)",
    id: "g88",
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 64 V 64 H 0 Z",
    id: "path72"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22,22)",
    id: "g82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    rx: 10,
    id: "rect74",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9,6)",
    id: "g80"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 8.2670002,
    r: 1,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m 1,0.267 v 4.2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleFilled);
export default __webpack_public_path__ + "static/media/exclamation-circle-filled.a4d3001b.svg";
export { ForwardRef as ReactComponent };